export enum AddinReceiverAgent {
  //   CreateCompsTable = "VisibleAlpha.Common.CommandsHandlers.CreateCompTableCommand",
  ResizeWizard = "VisibleAlpha.Common.CommandsHandlers.ResizeWizardCommand",
  CloseWizard = "VisibleAlpha.Common.CommandsHandlers.CloseWizardCommand",
  //   CreateEarningsPreview = "VisibleAlpha.Common.CommandsHandlers.CreateEarningsPreviewCommand",
  //   CreateRevisionAnalysis = "VisibleAlpha.Common.CommandsHandlers.CreateRevisionAnalysisCommand",
  //   CreateSourceComparison = "VisibleAlpha.Common.CommandsHandlers.CreateSourceComparisonCommand",
  //   GetRegistryCommandHandler = "VisibleAlpha.Common.CommandsHandlers.GetRegistryCommandHandler",
  //   SetRegistryCommandHandler = "VisibleAlpha.Common.CommandsHandlers.SetRegistryCommandHandler",
  //   RibbonCommandHandler = "VisibleAlpha.Common.CommandsHandlers.RibbonCommandHandler"
}

export enum URLs {
  getSearchTickers = "/comps/get_search_tickers", // This API is used to fetch list of tickers for a given keyword in search-ticker-box.
  getOtherDimMeta = "/api/get_other_dim_meta", // this API is used to fetch meta information of a ticker
  getSourceMeta = "/api/get_source_meta", // This API is used to get source meta information
  gridPanelsHistory = "/api/gridpanelshistory/", // This API used to set custom consensus for a given ticker and selected sources.
}
